
import React from 'react'
import { Icon, Button, OverflowMenu, MenuItem } from '@ui-kitten/components'
import { useAtomValue } from 'jotai'
import { currencyFormatterAtom } from '../global/AtomsProvider'

export const DiscountSelect = React.memo(function DiscountSelect(props) {

  const currencyFormatter = useAtomValue(currencyFormatterAtom)

  return (
    <OverflowMenu
      data={props.discountOptions}
      visible={props.discountMenuVisible}
      selectedIndex={props.discountSelectedIndex}
      onSelect={(index) => {
        if (index === 1 && props.discountSelectedIndex === 1) {
          props.setDiscountSelectedIndex(0)
          props.setDiscountAmount(0)
        } else {
          props.setDiscountSelectedIndex(index.row)
        }
        props.setDiscountMenuVisible(false)
      }}
      onBackdropPress={() => {
        props.setDiscountMenuVisible(!props.discountMenuVisible)
      }}
      anchor={() => (
        <Button
          appearance='outline'
          status={props.discountSelectedIndex == 0 ? 'basic' : 'primary'}
          style={[props.style, { paddingHorizontal: 0, flexDirection: 'row-reverse' }]}
          accessoryLeft={props.discountSelectedIndex === 1 ? undefined : (props) => (<Icon name='percent-outline' {...props} style={[props.style, {marginLeft: -10}]} />)}
          onPress={() => {
            props.setDiscountMenuVisible(!props.discountMenuVisible)
          }}
          testID="discount-select-button"
        >
          {props.discountSelectedIndex == 0 ? '  ' : (props.discountSelectedIndex === 1 ? ('-' + currencyFormatter.format(props.discountAmount)) : props.discountOptions[props.discountSelectedIndex]?.percentage) + ''}
        </Button>
      )}
    >
      {props.discountOptions.map((option, index) => (
        <MenuItem key={option.title} title={option.title} />  
      ))}
    </OverflowMenu>
  )
}, function(prev, next) {
  if (prev.discountMenuVisible !== next.discountMenuVisible) {
    return false
  }
  if (prev.discountSelectedIndex !== next.discountSelectedIndex) {
    return false
  }
  if (prev.discountAmount !== next.discountAmount) {
    return false
  }
  if (prev.discountOptions.length !== next.discountOptions.length) {
    return false
  }
  return true
})
